import React from "react"
import { ChevronDown, ChevronUp } from "react-feather"
import { Button } from "reactstrap"
import styles from "../ScoreCounter.module.scss"
import { updateVolleyballResult } from "../../../api/socket/functions"

function ScoreViewer({ score, isMatchDone }) {
	const onIncrement = (team) => updateScoreCounter(team, 1)
	const onDecrement = (team) => updateScoreCounter(team, -1)
	const spectate = localStorage.getItem("spectate")

	const updateScoreCounter = (team, points) => {
		const newScore = { ...score }
		const newPoints = newScore[team] + points >= 0 ? newScore[team] + points : 0
		newScore[team] = newPoints
		updateVolleyballResult(newScore)
	}

	const createPointArrows = (team) => {
		if (spectate || isMatchDone) return <></>
		return (
			<div className={styles.columnFlex}>
				<Button.Ripple
					color="flat-primary"
					size="sm"
					onClick={() => onIncrement(team)}
				>
					<ChevronUp />
				</Button.Ripple>
				<Button.Ripple
					color="flat-primary"
					size="sm"
					onClick={() => onDecrement(team)}
				>
					<ChevronDown />
				</Button.Ripple>
			</div>
		)
	}

	return (
		<div className={styles.rowFlex}>
			{createPointArrows("homeTeam")}
			<h2>
				{score.homeTeam} - {score.awayTeam}
			</h2>
			{createPointArrows("awayTeam")}
		</div>
	)
}

export default ScoreViewer
